import {ScrollSnapSlider} from "scroll-snap-slider";

export function initSnapSlider(el) {
    const sliderHTML = el.querySelector('.scroll-snap-slider');
    const slider = new ScrollSnapSlider({element: sliderHTML});
    const totalSlides = el.querySelectorAll('.scroll-snap-slide').length;
    const prev = el.querySelector('.carousel-control-prev');
    const next = el.querySelector('.carousel-control-next');
    let currentSlide = 0;

    const updateArrows = function () {
        prev.classList.toggle('disabled', currentSlide === 0);
        next.classList.toggle('disabled', currentSlide >= totalSlides);
    }
    updateArrows();

    const getPagesToSnap = function () {
        const clientWidth = document.documentElement.clientWidth;
        if(clientWidth >= 1200) return 6;
        if(clientWidth >= 992) return 4;
        if(clientWidth >= 768) return 3;
        if(clientWidth >= 576) return 2;
        return 1;
    }

    prev.addEventListener('click', function () {
        const pages = getPagesToSnap();
        currentSlide = currentSlide - pages < 0 ? 0 : currentSlide - pages;
        slider.slideTo(currentSlide);
        updateArrows();
    })
    next.addEventListener('click', function () {
        const pages = getPagesToSnap();
        currentSlide = currentSlide + pages > totalSlides ? totalSlides : currentSlide + pages;
        slider.slideTo(currentSlide);
        updateArrows();
    })
}